import React from 'react';
import './DealerPage.css';

import { Heading, PageTitle, Dealer } from '../../../components'; // Import necessary components from the components directory
import { dealers } from '../../../constants'; // Import the dealers data from the constants directory



const DealerPage = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Dealers'} page={'Dealers'} />

      <section className='dealers'>

        {/* Section heading */}
        <Heading title={'Car Dealers'} subTitle={'The Car Experts'} />

        {/* Container for Dealer Cards */}
        <div className='box-container'>

          {/* Map over the services array to render each service */}
          {dealers.map((dealer) => {
            // Dealer Component: Renders individual dealer details
            return <Dealer key={dealer.id} dealer={dealer} />
          })}

        </div>

      </section>

    </>

  )
}

export default DealerPage;